'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { reportWebVitals } from '@/lib/web-vitals';

export default function WebVitals() {
    useReportWebVitals(reportWebVitals);

    return null; // This component doesn't render anything
} 